import Array from './Array'
import Boolean from './Boolean'
import Date from './Date'
import DateTime from './DateTime'
import Enum from './Enum'
import Integer from './Integer'
import Object from './Object'
import String from './String'

export default [Array, Boolean, Date, DateTime, Enum, Integer, Object, String]


// WEBPACK FOOTER //
// ./src/components/metadataeditor/template/default/mappings.js